import React from "react";
import { footer } from "../../../styles/theme";

const Footer = () => (
  <footer
    style={{ 
      ...footer.container, 
      textAlign: "center", 
      fontSize: "13px", 
      color: "#777", 
      lineHeight: "1.6", 
      padding: "30px 20px" 
    }}
  >
    <p>
      PathoTrack is supported by funding from the <strong>Missouri Department of Health and Senior Services (MDHSS)</strong>—Contract #AOC23380006 and the <strong>National Science Foundation (NSF) Cybersecurity Innovation</strong> OAC-2232889 to TJ.
    </p>
    <p>
      It was also supported by the <strong>National Institute of General Medical Sciences of the National Institutes of Health</strong> under Award Number P20GM103434 to TJ.
    </p>
    <p>
      &copy; {new Date().getFullYear()} PathoTrack. All rights reserved.
    </p>
  </footer>
);

export default Footer;